// istanbul ignore file
import React, { ReactElement, memo } from 'react'

import dateUtils from '@lib/date'

export interface TimeProps {
  date: Date
  isLocalized?: boolean
}

const Time = ({ date, isLocalized }: TimeProps): ReactElement => {
  if (isLocalized) {
    const string = dateUtils.format(date, 'hh:mm aaa')
    const [time, amPm] = string.split(' ')

    return (
      <>
        <span className="station-time__time">{time}</span>
        <span className="station-time__am-pm">{amPm}</span>
      </>
    )
  }

  return <>{dateUtils.format(date, 'p')}</>
}

export default memo(Time)
